import React, { Suspense, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { MainLoader, SideNav, TopNav, SuspenseLoader } from "../../CommonComponent";

const DashboardLayout = () => {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  return (
    <div
      className={`screen-area ${
        isSidebarOpen ? "sidebar-open" : "sidebar-closed"
      }`}
    >
      <TopNav />
      <div className="d-flex">
        <SideNav isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <div className="content-area">
          <Suspense fallback={<SuspenseLoader />}>
            <Outlet key={location.pathname} />
          </Suspense>
        </div>
      </div>
      <MainLoader />
    </div>
  );
};

export default DashboardLayout;
